import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Navbar from "./components/feature/Navbar";
import Footer from "./components/feature/Footer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";

import ScrollToTop from "./components/feature/ScrollToTop";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col">
          <Navbar />
          <div className="flex-1">
            <AppRoutes />
          </div>
          <Footer />
          <ToastContainer
            position="bottom-left"
            autoClose={2000}
            closeOnClick
            pauseOnFocusLoss
            pauseOnHover
            draggable
            draggablePercent={0.6}
            hideProgressBar
            closeButton={false}
            rtl={false}
            theme="dark"
          />
        </div>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;